var Curriculog = Curriculog || {};

Curriculog.ProposalForm.ProposalEntityDropdownView = (function ($, _, Backbone, ProposalEntityDropdownView) {

	ProposalEntityDropdownView = Curriculog.HierarchyDropdownView.extend({

		render: function () {
			this.$el.empty();

			if (this.collection.length > 0 && this.ineligible.length < this.entities.length) {
				var rootNodeIDs = this.collection.findRoots();
				var rootEntities = this.entities.getSortedEntities(rootNodeIDs);
				var depth = 0;

				for (var i=0; i < rootEntities.length; i++) {
					var currentEntity = rootEntities[i];
					var entity = currentEntity.toJSON();

					if (entity.status == 'inactive') {
						continue;
					}

					var subView = new Curriculog.ProposalEntityDropdownItemView({
						entity: currentEntity,
						depth: depth,
						ineligible: this.ineligible,
						allowInactive: this.allowInactive
					});

					var last = $(subView.el).appendTo(this.$el);
					this.subviews.push(subView);
					this.renderChildren(currentEntity.get('id'), last, depth+1);
				}
			} else {
				this.renderEmptyList();
			}
		},

		renderChildren: function (id, last, depth) {
			var childIDs = this.collection.findChildren(id);
			var childEntities = this.entities.getSortedEntities(childIDs);

			for (var i=0; i < childEntities.length; i++) {
				var currentEntity = childEntities[i];
				var entity = currentEntity.toJSON();

				if (entity.status == 'inactive') {
					continue;
				}

				var subView = new Curriculog.ProposalEntityDropdownItemView({
					entity: currentEntity,
					depth: depth,
					ineligible: this.ineligible,
					allowInactive: this.allowInactive
				});

				var lastElement = $(subView.el).appendTo(this.$el);
				this.subviews.push(subView);
				this.renderChildren(currentEntity.get('id'), lastElement, depth+1);
			}
		}
	});
	return ProposalEntityDropdownView;

})($, _, Backbone, Curriculog.ProposalEntityDropdownView || {});
